module.exports = __webpack_public_path__ + "static/images/accept-btn.fd49aab.png";